"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

var gStripe = global.Stripe;

var _Symbol = function () {
  if (global.Symbol) return global.Symbol;
  var SymID = 0;
  var Symbols = [];
  return function _Symbol2(text) {
    var ST = "$_Symbol_" + text;

    if (Symbols.indexOf(ST) == -1) {
      Symbols.push(ST);
      return ST;
    }

    ST = "".concat(ST, "_").concat(SymID++);
    Symbols.push(ST);
    return ST;
  };
}();

var StripeSym = _Symbol('Stripe');

function successField(field) {
  return function (target, name, descriptor) {
    return Object.assign({}, descriptor, {
      value: function value() {
        var value;
        if (descriptor.initializer) value = descriptor.initializer.call(this);else if (descriptor.value) value = descriptor.value;else if (descriptor.get) value = descriptor.get.call(this);

        if (typeof value == 'function') {
          var _value;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          value = (_value = value).call.apply(_value, [this].concat(args));
        }

        if (babelHelpers.typeof(value) == 'object' && value && value.then) {
          return value.then(function (value) {
            if (value.error) throw value.error;
            return value[field];
          });
        }

        if (babelHelpers.typeof(value) == 'object' && value) {
          if (value) throw value.error;
          return value[field];
        }

        return value;
      }
    });
  };
}

function proxy(target, name) {
  return {
    enumerable: false,
    configurable: true,
    value: function value() {
      var _this$StripeSym;

      return (_this$StripeSym = this[StripeSym])[name].apply(_this$StripeSym, arguments);
    }
  };
}

function wrap(Instance) {
  return function (target, name, descriptor) {
    return Object.assign({}, descriptor, {
      value: function value() {
        var value;
        if (descriptor.initializer) value = descriptor.initializer.call(this);else if (descriptor.value) value = descriptor.value;else if (descriptor.get) value = descriptor.get.call(this);

        if (typeof value == 'function') {
          var _value2;

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          value = (_value2 = value).call.apply(_value2, [this].concat(args));
        }

        if (babelHelpers.typeof(value) == 'object' && value && value.then) {
          return value.then(function (value) {
            return new Instance(value);
          });
        }

        return new Instance(value);
      }
    });
  };
}

var Stripe = (_dec = successField('token'), _dec2 = successField('source'), _dec3 = successField('source'), (_class = (_temp = function Stripe() {
  babelHelpers.classCallCheck(this, Stripe);
  babelHelpers.initializerDefineProperty(this, "elements", _descriptor, this);
  babelHelpers.initializerDefineProperty(this, "createToken", _descriptor2, this);
  babelHelpers.initializerDefineProperty(this, "createSource", _descriptor3, this);
  babelHelpers.initializerDefineProperty(this, "retrieveSource", _descriptor4, this);
  babelHelpers.initializerDefineProperty(this, "paymentRequest", _descriptor5, this);
  this[StripeSym] = gStripe.apply(void 0, arguments);
}, _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "elements", [proxy], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "createToken", [_dec, proxy], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "createSource", [_dec2, proxy], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "retrieveSource", [_dec3, proxy], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "paymentRequest", [proxy], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
exports.default = Stripe;